import type { EarlyLeaveReason } from "../types";

// HA-368: the early-leave reasons, the set HA-269's manager view shows (D-HA-12). The values are the server's EarlyLeaveReason.
export const earlyLeaveReasons: readonly {
	value: EarlyLeaveReason;
	label: string;
}[] = [
	{ value: "Illness", label: "Illness" },
	{ value: "SentHome", label: "Sent Home" },
	{ value: "Other", label: "Other" },
];

export const EARLY_LEAVE_NOTE_MAX = 250;
